export const MAFIA_SERVER_ERROR = 500;
export const MAFIA_AUTH_ERROR = 401;
export const MAFIA_LOGIN_ERROR = 400;
export const MAFIA_ACCESS_ERROR = 403;
export const MAFIA_ERROR_STATUS = 422;
export const MAFIA_GAME_ERRORS = 100;
export const MAFIA_PAY_ERROR = 0;
